import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent {
  toMakeButtons : any[] = [];

  constructor(){
    this.toMakeButtons = [{ path: '/dashboard', name: 'Go back to Dashboard', icon: 'satellite_alt' }];
  }
}
